import React from 'react';
import '../App.css'

function Header(props) {
      return (
        <div className="header">
            <div className="profile_image">
                <img src="me_ICPC2.png" alt="me" onClick={props.reset_page} style={{cursor:"pointer"}}></img>  
            </div>
            <div className="custom_break"></div>
            <div className="profile_data">
                <p className="name">Michael Crowley</p>
                <p className="job">Computer Systems Engineer at Lawrence Berkeley National Lab</p>
                {/* <p className="contact-info">(631) 294-3220 | michaelcpesce@gmail.com | Tucson, AZ</p>             */}
            </div>
        </div>
      )
}

export default Header;